module.exports = __webpack_public_path__ + "static/img/weezie_fiber_compact_blue.a3d01a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/weezie_fiber_compact_blue.png
// module id = K7+Q
// module chunks = 0